import React, { Component } from 'react'

import BlockMap from './../../Block/BlockMap'
import BlockAudio from './../../Block/BlockAudio'
import BlockVideo from './../../Block/BlockVideo'
import BlockText from './../../Block/BlockText'
import BlockImage from './../../Block/BlockImage'

class StepBody extends Component {
  /**
   * Display the right bloc component from the bloc layout
   * @param {String} layout layout of the bloc (image, texte, audio...)
   * @param {Number} id id of the trip
   * @param {Object} datas datas (content) of the bloc
   */
  displayBlocFromLayout(layout, index, datas) {
    switch (layout) {
      case 'bloc_bande_son':
        return (
          <div key={`${layout}-${index}`} className="step__holder">
            <BlockAudio bloc={datas} />
          </div>
        )
      case 'bloc_images_animees':
        return (
          <div key={`${layout}-${index}`} className="step__holder step__holder--full">
            <BlockImage alignement={datas.image_position} bloc={datas} />
          </div>
        )
      case 'bloc_texte':
        return (
          <div key={`${layout}-${index}`} className="step__holder">
            <BlockText bloc={datas} />
          </div>
        )
      case 'bloc_video':
        return (
          <div key={`${layout}-${index}`} className="step__holder step__holder--full">
            <BlockVideo bloc={datas} />
          </div>
        )
      default:
        return null
    }
  }
  render() {
    const {
      step,
      step: {
        blocs_blocs,
        step_img,
        step_name,
      },
      toggleMap,
      trip,
    } = this.props

    return (
      <div className="step">
        <div className="step__inner">
          <div className="step__holder">
            <h3 className="step__title">{step_name}</h3>
            {step_img && <BlockMap step={step} toggleMap={toggleMap} />}
          </div>
          {blocs_blocs && blocs_blocs.map((bloc, index) => this.displayBlocFromLayout(bloc.acf_fc_layout, `${trip.id}-${index}`, bloc))}
        </div>
      </div>
    )
  }
}

export default StepBody


// WEBPACK FOOTER //
// ./src/components/Step/StepBody/StepBody.js